import OAuthAPI from '@/features/api/oauth/oauth'
import {
    MissingDeviceCredentialError,
    MissingRefreshTokenError,
} from '@/features/api/terminal/errors'
import { oauthAccessToken } from '@/features/auth/oauthAccessToken'
import StorageService from '@/services/storage'

interface Credentials {
    deviceId: string
    deviceToken: string
    refreshToken: string
}

class OAuthTokenRefresh {
    private refreshPromise: Promise<string> | null = null

    refreshAccessToken = async (): Promise<string> => {
        this.refreshPromise ??= this.refresh().finally(() => {
            this.refreshPromise = null
        })

        return this.refreshPromise
    }

    private refresh = async (): Promise<string> => {
        const { deviceId, deviceToken, refreshToken } = await this.loadCredentialsFromStorage()

        const response = await OAuthAPI.refreshTokens(deviceId, deviceToken, refreshToken)

        const { accessToken, refreshToken: newRefreshToken } = response

        oauthAccessToken.set(accessToken)

        await StorageService.setRefreshToken(newRefreshToken)

        return accessToken
    }

    private loadCredentialsFromStorage = async (): Promise<Credentials> => {
        const [deviceId, deviceToken, refreshToken] = await Promise.all([
            StorageService.getDeviceId(),
            StorageService.getDeviceToken(),
            StorageService.getRefreshToken(),
        ])

        if (!deviceId || !deviceToken) {
            throw new MissingDeviceCredentialError(
                'Missing required credential: "deviceId" or "deviceToken"'
            )
        }

        if (!refreshToken) {
            throw new MissingRefreshTokenError('Missing required credential: "refreshToken"')
        }

        return { deviceId, deviceToken, refreshToken }
    }
}

export const oauthTokenRefresh = new OAuthTokenRefresh()
